import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-material-ui";
import { Grid } from "@mui/material";
import axios from "axios";
import ENV from "../../../environment";
import { useParams } from "react-router-dom";
import { text } from "tts-hrp-val-lib";
import { Checkbox } from "antd";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

function TransitionsModal({ getData, currencyTypes }) {
    const { hotelid } = useParams();
    const qy = document.querySelector.bind(document);
    const [loading, setLoading] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [share, setShare] = React.useState(false);
    const onChange = (e) => {
        setShare(e.target.checked);
    };

    const pricesSchema = Yup.object(
        currencyTypes.reduce((acc, currency) => {
            acc[currency.abbreviation] = Yup.number()
                .typeError("Must be a number")
                .required("Required");
            return acc;
        }, {})
    );

    const validate = Yup.object({
        name: Yup.string().required("Field is required").matches(text, { message: "value invalid" }),
        description: Yup.string().optional("description is required").nullable().matches(text, { message: "invalid value" }),
        prices: pricesSchema,
        number_of_people: Yup.string().required("Field is required"),
        file: Yup.string().optional().nullable(),
    });
    const emptyData = {
        name: "",
        description: "",
        prices: currencyTypes.reduce((acc, currency) => {
            acc[currency.abbreviation] = "";
            return acc;
        }, {}),
        number_of_people: "",
        file: "",
    };

    const onSubmit = async (values) => {
        const body = new FormData();

        body.append("name", values.name);
        body.append("prices", JSON.stringify(values.prices));
        body.append("number_of_people", values.number_of_people);
        body.append("is_shared", share);
        if (values?.description) {
            body.append("description", values.description);
        }
        if (qy(`#file`)?.files[0]) {
            body.append("file", qy(`#file`).files[0]);
        }

        setLoading(true);
        await axios
            .post(`${ENV.URL}/api/hdp/tts/adm/hotel/category/${hotelid}`, body, {
                headers: {
                    Authorization: sessionStorage.getItem("token"),
                    "client-id": ENV.CLIENTID,
                    "client-secret": ENV.SECRET,
                },
            })
            .then((res) => {
                setLoading(false);
                toast.success("Saved successfully", { autoClose: 2000 });
                handleClose();
                getData();
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.errors[0]?.message || "An error occurred");
            });
    };

    return (
        <div className="modal_res">
            <Button onClick={handleOpen} variant="contained" style={{ float: "right" }}>
                Add Category
            </Button>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{ backdrop: { timeout: 500 } }}
            >
                <Fade in={open}>
                    <Box sx={style} className="modal_res">
                        <Typography id="transition-modal-title" variant="h6" component="h2" className="marginBottom">
                            Enter category info
                        </Typography>
                        <Formik
                            initialValues={emptyData}
                            validationSchema={validate}
                            onSubmit={async (values) => {
                                onSubmit(values);
                                return new Promise((res) => setTimeout(res, 500));
                            }}
                        >
                            {({ values, errors }) => (
                                <Form autoComplete="off" className="mt-4">
                                    <Grid container spacing={4}>
                                        <Grid item xs={12}>
                                            <Field fullWidth name="name" size="small" component={TextField} label={"Name"} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field fullWidth name="description" size="small" component={TextField} label={"Description"} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                fullWidth
                                                name="number_of_people"
                                                size="small"
                                                component={TextField}
                                                label={"Number of people"}
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Field
                                                id={"file"}
                                                fullWidth
                                                size="small"
                                                name={"file"}
                                                inputProps={{ accept: "image/*" }}
                                                component={TextField}
                                                type="file"
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Checkbox onChange={onChange}>{"shared"}</Checkbox>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography id="transition-modal-title" variant="h6" component="h5" className="marginBottom">
                                                Prices
                                            </Typography>
                                            <Grid container spacing={2}>
                                                {
                                                    currencyTypes?.map((currency) => (
                                                        <Grid item xs={6} key={currency.abbreviation}>
                                                            <Field
                                                                fullWidth
                                                                name={`prices.${currency.abbreviation}`}
                                                                size="small"
                                                                component={TextField}
                                                                label={currency.abbreviation}
                                                                type="number"
                                                            />
                                                        </Grid>
                                                    ))
                                                }
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                    <div className="right_left">
                                        <Button onClick={handleClose} variant="contained" sx={{ mt: 3, mb: 2 }} color="error">
                                            Close
                                        </Button>
                                        <>
                                            {loading ? (
                                                <LoadingButton loading variant="contained" sx={{ mt: 3, mb: 2 }} color="success">
                                                    Submit
                                                </LoadingButton>
                                            ) : (
                                                <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }} color="success">
                                                    Submit
                                                </Button>
                                            )}
                                        </>
                                    </div>
                                    {loading && <div className="overlay" />}
                                </Form>
                            )}
                        </Formik>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}

export default React.memo(TransitionsModal);
